import {
  customerCurrency,
  includedOptions,
  maintenanceSLAOptions,
} from "@/common/const/filter-options";
import maintenanceTypeOptions from "@/common/const/filter-options/maintainanceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const hardwareQuoteLineFormStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "targetCurrency",
    required: false,
    readonly: true,
    inputType: "select",
    options: customerCurrency,
  },

  {
    inputType: "text",
    label: "OTC",
    name: "targetOTC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "MRC",
    name: "targetMRC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Quote Type",
    required: false,
    readonly: true,
    name: "quoteType",
  },
  {
    inputType: "text",
    label: "OEM/Manufaturer Name",
    name: "manufaturerName",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Product Code/Part Number",
    name: "productCode",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: false,
    readonly: true,
    options: [...contractTermsOptions],
  },
  {
    inputType: "select",
    label: "Purchase Type",
    name: "purchaseType",
    required: false,
    readonly: true,
    options: [
      { label: "Resale", value: "Resale" },
      {
        label: "Rental",
        value: "Rental",
      },
    ],
  },

  {
    inputType: "select",
    label: "Maintenance Type",
    name: "maintenanceType",
    required: false,
    readonly: true,
    options: maintenanceTypeOptions,
  },
  {
    inputType: "select",
    label: "Maintenance SLA",
    name: "maintenanceSla",
    required: false,
    readonly: true,
    options: maintenanceSLAOptions,
  },
  {
    inputType: "select",
    label: "Maintenance Status",
    name: "maintenanceStatus",
    required: false,
    readonly: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "License Name",
    name: "licenseName",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "License Status",
    name: "licenseStatus",
    required: false,
    readonly: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "On-site Delivery Included",
    name: "onSiteDeliveryIncluded",
    required: false,
    readonly: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "On-site Installation Included",
    name: "onSiteInstallationIncluded",
    required: false,
    readonly: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "Custom/Duties Included",
    name: "dutiesIncluded",
    required: false,
    readonly: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    readonly: true,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];
export default hardwareQuoteLineFormStrategy;
